import AuthScreenContainer from './AuthScreenContainer';

export default AuthScreenContainer;
